module.exports = __webpack_public_path__ + "static/media/clinical-vaccine-bg.7691a7d0.png";